import { IPlanContent } from '../typings/planContent.types';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  gasKeyDetailsAddons,
} from './common/planDefaults';

import { defaultHSKeyDetails, homeSupportContent } from './HomeSupport/homeSupport';
import { InternetOfferPerk } from './common/internetOfferPerk';
export const originEssentialVariableContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Essentials Variable']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: defaultHSKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: gasKeyDetailsAddons,
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    uiOptions: homeSupportContent.content.uiOptions,
    estimatesDialog: defaultEstimatesDialog(),
  },
};
